<!-- 自助工具-建发识别图片 -->
<template>
    <div class="div">
        <!-- 添加图片区域 -->
        <div class="upload_box">
            <el-upload class="upload-demo" action="#" :auto-upload="false" :limit="1" accept=".jpg,.jpeg,.png,.bmp"
                :on-change="handleChange" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
                <el-button plain type="primary" size="mini" icon="el-icon-picture">添加图片</el-button>
            </el-upload>
            <el-button plain type="success" size="mini" @click="startOcr">开始识别</el-button>
        </div>
        <!-- 图片预览 -->
        <div v-if="previewUrl" class="preview_box">
            <img :src="previewUrl" class="preview_img" alt="识别图片">
        </div>
        <!-- 识别结果表格 -->
        <el-table :data="tableData" border size="mini" style="width: 100%; margin-top: 10px;">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="skuName" label="品名" min-width="120"></el-table-column>
            <el-table-column prop="spec" label="规格" min-width="100"></el-table-column>
            <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
            <el-table-column prop="orderQty" label="订购数量" width="100" align="right"></el-table-column>
            <el-table-column prop="pickQty" label="拣货数量" width="100" align="right"></el-table-column>
            <el-table-column prop="grossWeight" label="毛重" width="100" align="right"></el-table-column>
            <el-table-column prop="netWeight" label="净重" width="100" align="right"></el-table-column>
            <el-table-column prop="cdNo" label="指令编号" min-width="140"></el-table-column>
            <el-table-column prop="blNo" label="提单号" min-width="120"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 选中的图片列表
            fileList: [],
            // 图片预览地址
            previewUrl: '',
            // 识别结果
            tableData: []
        }
    },
    methods: {
        // 选择图片
        handleChange(file, fileList) {
            // 校验图片格式
            var FileExt = file.name.replace(/.+\./, '').toLowerCase();
            const whiteList = ["jpg", "jpeg", "png", "bmp"];
            if (whiteList.indexOf(FileExt) === -1) {
                this.$message.error('只能上传jpg/jpeg/png/bmp格式的图片！');
                this.fileList = [];
                this.previewUrl = '';
                return;
            }
            // 校验图片大小 10M
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$message.warning('图片大小不能超过10M！');
                this.fileList = [];
                this.previewUrl = '';
                return;
            }
            // 只保留一张图片
            this.fileList = fileList;
            // 生成图片预览地址
            this.previewUrl = URL.createObjectURL(file.raw);
        },
        // 移除图片
        handleRemove(file, fileList) {
            this.fileList = fileList;
            this.previewUrl = '';
        },
        // 超过一张图片提示
        handleExceed() {
            this.$message.warning('只能选择一张图片！');
        },
        // 开始识别
        startOcr() {
            if (this.fileList.length === 0) {
                this.$message.warning('请先添加图片！');
                return;
            }
            const file = this.fileList[0].raw;
            const formData = new FormData();
            formData.append('pic', file);
            // 调用识别接口
            this.$api.ocrCnCdPulp(formData).then(res => {
                this.$message({
                    type: 'success',
                    message: '识别成功'
                });
                this.tableData = res;
            });
        }
    }
}
</script>

<style lang="css" scoped>
.div {
    background-color: white;
    padding: 10px;
}

.upload_box {
    display: flex;
    align-items: center;
}

.upload_box .el-upload {
    margin-right: 10px;
}

.preview_box {
    margin-top: 10px;
}

.preview_img {
    max-width: 300px;
    max-height: 300px;
    border: 1px solid #ddd;
    border-radius: 4px;
}
</style>
